import { useCallback, useState } from 'react';

function useAsync(asyncFunction) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);

  const wrappedFunction = useCallback(
    async (...args) => {
      setPending(true);
      setError(null);
      try {
        return await asyncFunction(...args);
      } catch (e) {
        setError(e);
      } finally {
        setPending(false);
      }
      return undefined;
    },
    [asyncFunction],
  );

  return [pending, error, wrappedFunction];
}

export default useAsync;
